<template>
  <div class="container roundedBorder secondary-bg primary-fg" style="padding: 20px;">
    <h1 class="primary-fg">Oops, 404!</h1>
    <h5 class="secondary-fg">This is not the web page you are looking for.</h5>
    <a
    v-on:click="$router.push({ path: '/' })"
      style="margin: 20px 0 20px 0px"
      class="waves-effect waves-light primary-bg primary-fg btn s12"
    >Back to the homepage</a>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  metaInfo: {
    title: "Not Found",
    meta: [
      {
        name: "description",
        content:
          "Requested page was not found, navigate back to the homepage. | Password Manager | Encrypted Passwords | Encrypted Notes | Generate a new strong password",
      },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {name: 'keywords', content: 'LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application'}
    ],
  },
};
</script>
